<kendo-card
  orientation="horizontal"
  class="border-t-2 border-r-2 border-b-2 border-l-8 {{
    statusAlertState().borderColor
  }}"
>
  <kendo-card-header class="w-full k-hstack">
    <kendo-avatar
      class="mr-3"
      fillMode="outline"
      [border]="false"
      size="large"
      [themeColor]="statusAlertState().themeColor"
      iconClass="fa-duotone {{ statusAlertState().icon }}"
      shape="square"
    ></kendo-avatar>
    <div class="grid w-full grid-flow-col gap-0">
      <div class="w-full">
        <h3 kendoCardTitle class="font-bold {{ statusAlertState().color }}">
          @if (statusAlertState().title && this.shouldTranslateTitle()) {
            {{ statusAlertState().title | translate }}
          } @else {
            {{ statusAlertState().title }}
          }
        </h3>

        <p kendoCardSubtitle>
          @if (message() && this.shouldTranslateMessage()) {
            {{ message() | translate }}
          } @else {
            {{ message() }}
          }
        </p>
      </div>
    </div>
  </kendo-card-header>
</kendo-card>
